import { render, staticRenderFns } from "./labelDialog.vue?vue&type=template&id=7d58f0d1&scoped=true"
import script from "./labelDialog.vue?vue&type=script&lang=js"
export * from "./labelDialog.vue?vue&type=script&lang=js"
import style0 from "./labelDialog.vue?vue&type=style&index=0&id=7d58f0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d58f0d1",
  null
  
)

export default component.exports